import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Shield, Search, BarChart3, Ban, Settings, Menu, X, Sun, Moon, User, LogIn } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { signIn } from '../services/auth';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { state, toggleTheme } = useApp();

  const links = [
    { to: '/', icon: Search, label: 'Lookup' },
    { to: '/dashboard', icon: BarChart3, label: 'Dashboard' },
    { to: '/blocklist', icon: Ban, label: 'Block List' },
    { to: '/settings', icon: Settings, label: 'Settings' },
  ];

  const isActive = (path) => location.pathname === path;

  const handleSignIn = async () => {
    try {
      await signIn('Google');
    } catch (err) {
      console.error('Sign in failed:', err);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand" onClick={() => setMobileOpen(false)}>
          <div className="navbar-logo">
            <Shield size={24} />
          </div>
          <span className="navbar-title">SpamBlocker</span>
        </Link>

        <div className={`navbar-links ${mobileOpen ? 'open' : ''}`}>
          {links.map(({ to, icon: Icon, label }) => (
            <Link
              key={to}
              to={to}
              className={`navbar-link ${isActive(to) ? 'active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              <Icon size={18} />
              <span>{label}</span>
            </Link>
          ))}
        </div>

        <div className="navbar-actions">
          {state.isAuthenticated ? (
            <Link to="/settings" className="navbar-user-btn" aria-label="User profile">
              <User size={18} />
            </Link>
          ) : (
            <button className="navbar-signin-btn" onClick={handleSignIn} aria-label="Sign in">
              <LogIn size={18} />
            </button>
          )}
          <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
            {state.theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
    </nav>
  );
}
